import { render, staticRenderFns } from "./IconBack.vue?vue&type=template&id=8cc8c3b0&"
import script from "./IconBack.vue?vue&type=script&lang=js&"
export * from "./IconBack.vue?vue&type=script&lang=js&"
import style0 from "./IconBack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports